import type { LivestreamRequest, LivestreamResponse } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import HttpStatusCode from '../../request/HttpStatusCode';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class LivestreamRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getLivestream = async ({ deviceId }: LivestreamRequest): Promise<LivestreamResponse> => {
    const requestData: IRequest = {
      endpoint: `/cameras/livestream/devices/${deviceId}`,
      method: HttpMethod.GET,
    };

    const { data } = await this.requester.request(requestData, [HttpStatusCode.NOT_FOUND]);

    return data;
  };

  public closeLivestream = async ({ deviceId }: LivestreamRequest): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/cameras/livestream/devices/${deviceId}`,
      method: HttpMethod.DELETE,
    };

    await this.requester.request(requestData);
  };
}

export default LivestreamRequester;
